module.exports = __webpack_public_path__ + "static/media/Scroll_Buttons@3x.d56514da.png";